/* eslint-disable @typescript-eslint/no-explicit-any */
import Layout from '../../../../common/components/layout/Layout';
import Header from '../../../../common/components/layout/Header';
import PaymentLabels from '../../../../common/components/modules/sports/PaymentLabelsLeft';
import Button from '../../../../common/components/sections/Button';
import LayoutInside from '../../../../common/components/layout/LayoutInside';
import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../../../context/auth-context';
import { useDispatch, useSelector } from 'react-redux';
import { getSlotPrices } from '../../../../modules/sport/actions/reducerPrices';
import { createReservation } from '../../../../modules/sport/actions/reducerReservations';
import { IPriceRent } from '../../../../modules/sport/interfaces/field';
import Loading from '../../../../common/loading/Loading';
import Image from '../../../../common/Image';

import WebPayLogo from '../../../../common/components/images/webpay-plus.svg';
import { attributesBySport } from '../../../../common/data/attributes';

import { createModel2 } from '../../../../services/payment.service';
import { formatPrice } from '../../../../utils';
import MsjSuccess from '../../../../common/components/sections/MsjSuccess';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ClubsPayment = (): JSX.Element => {
    const attribute = attributesBySport('rent');
    const auth = useAuth();
    const location = useLocation();
    const dispatch = useDispatch();

    const selectReservations = (state: any) => state.reservations;
    const reservations = useSelector(selectReservations);

    const selectListPrices = (state: any) => state.priceState;
    const priceState = useSelector(selectListPrices);

    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const query = useQuery();
    const title = query.get('title');
    const nameUrl = query.get('name');
    const emailUrl = query.get('email');
    const phoneUrl = query.get('phone');
    const date = query.get('date');
    const start = query.get('start');
    const end = query.get('end');
    const fieldName = query.get('fieldName');
    const price = query.get('price');
    const club = query.get('club');
    const field = query.get('field');
    const dateEnd = query.get('dateEnd');
    const dateStart = query.get('dateStart');
    const nameClub = query.get('nameClub');
    const slot = query.get('slot');
    const fieldId = query.get('fieldId');
    const address = query.get('address');
    const [error, setError] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [priceRent, setPriceRent] = useState<IPriceRent>();
    const [isRedirecting, setIsRedirecting] = useState(false);
    const day = query.get('day');
    const region = query.get('region');
    const pathnameClubs = `/${sport}/arrienda/clubes/filter?region=${region}&day${day}`;
    const pathnameAll = window.location.pathname + useLocation().search;
    const [deposit, setDeposit] = useState<number>();
    const [msj, setMsj] = useState<string>('');
    const [statusReservations, setStatusReservations] = useState(false);
    const inputRefButton = useRef<HTMLDivElement>();

    const breads = [
        {
            key: 'sport',
            name: 'Arrienda',
            url: `/arrienda`,
            add: true,
        },
        {
            key: 'clubes',
            name: 'Clubes',
            url: pathnameClubs,
            add: false,
        },
        {
            key: 'reservar',
            name: 'reservar',
            url: `/arrienda/reservar/filter?day=${day}&club=${club}`,
            add: true,
        },
        {
            key: 'pago',
            name: 'pago',
            url: pathnameAll,
            add: false,
        },
    ];

    const filter = {
        sport,
        emailUrl,
        phoneUrl,
        date,
        start,
        nameUrl,
        end,
        fieldName,
        price,
        field,
        club,
        slot,
        title,
        dateStart,
        dateEnd,
        fieldId,
        address,
    };

    useEffect(() => {
        const createPayment = async () => {
            try {
                console.log('aqui llegue');
                const response = await createModel2('payments/create/latam')({
                    reservationId: reservations.data.data.id,
                    provider: 'WEBPAY',
                });
                console.log('aqui response', { response });
                const data = await response.json();
                console.log('aqui data', { data });
                if (data?.data?.url) {
                    // const url = `${response.data.url}?token_ws=${response.data.token}`;
                    window.location.href = data.data.url;
                }
                setIsRedirecting(false);
            } catch (error) {
                //console.log('aqui llegue', { error });
                setIsRedirecting(false);
                setError(
                    'Ocurrio un error, le notificaremos al correo para que pueda realizar el pago correspondiente',
                );
            }
        };
        setError('');
        console.log('reservations:', reservations, reservations?.data?.data?.paymentMethodCode);
        if (reservations.error) {
            setError('Ocurrio un error, le notificaremos al correo para que pueda realizar esta reservación');
        } else {
            if (reservations.isLoading) {
                // console.log('reservations esta cargando');
            } else {
                if (reservations?.data?.data?.id && reservations?.data?.data?.paymentMethodCode) {
                    if (
                        reservations?.data?.data?.paymentMethodCode === 'DEPOSIT' ||
                        reservations?.data?.data?.paymentMethodCode === 'ONLINE'
                    ) {
                        console.log('Go to payment');
                        setStatusReservations(false);
                        createPayment();
                    }
                    if (reservations?.data?.data?.paymentMethodCode === 'CASH') {
                        setStatusReservations(true);
                    }
                }
            }
        }
    }, [reservations]);

    useEffect(() => {
        if (price) {
            setStatusReservations(false);
            dispatch(getSlotPrices({ pricesId: price, clubId: '', calculateFor: '' }));
        }
    }, [price]);

    useEffect(() => {
        if (priceState && priceState.data && priceState.data.data && priceState.data.data.length >= 0) {
            setPriceRent(priceState.data.data[0]);
        }
    }, [priceState]);

    useEffect(() => {
        if (priceRent) {
            if (
                priceRent.paymentMethods &&
                priceRent.paymentMethods.code &&
                priceRent.paymentMethods.code === 'DEPOSIT' &&
                priceRent.discountPercentage > 0
            ) {
                const total = priceRent.basePrice * (priceRent.discountPercentage / 100);
                if (total && total > 0) {
                    setMsj(`Debes abonar ${formatPrice(total, 0)}, y el resto cancelarlo en la cancha`);
                }

                setDeposit(total);
            } else {
                setDeposit(priceRent.basePrice);
            }
        }
    }, [priceRent]);

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        setError('');
        setIsRedirecting(true);
        const paymentMethodId = priceRent.paymentMethods?.id;
        const payload = {
            start: filter.dateStart,
            end: filter.dateEnd,
            fieldId: filter.fieldId,
            priceId: priceRent && priceRent.id,
            methodsId: paymentMethodId,
        };

        if (!error) {
            dispatch(createReservation(payload));
        }
    };

    useEffect(() => {
        if (auth && auth.isLoggedIn && auth.user) {
            setName(auth.user.firstName + ' ' + auth.user.lastName);
            setEmail(auth.user.email);
            setPhone(auth.user.phone ? auth.user.phone : '');
        }
        /* setTimeout(function () {
            const coordinates = inputRefButton.current.getBoundingClientRect();
            //scrollToGo(coordinates.x, coordinates.y + coordinatesField.height);
            window.scrollTo({ top: coordinates.y, behavior: 'smooth' });
        }, 300);*/
    }, [auth]);

    return (
        <Layout navProps={{ title: 'Pago Arriendo | Supermatch', description: 'Arrienda Supermatch' }}>
            <>
                <Header />
                <LayoutInside attribute={attribute} title={`Pago para la ${filter.fieldName}`} breads={breads}>
                    <>
                        {error && (
                            <div className="flex flex-col mx-auto w-full md:w-1/3 mb-2 text-center  font-bold">
                                <p className="w-full my-6 text-red-500">*{error}</p>
                            </div>
                        )}
                        {msj && (
                            <div className="flex flex-col mx-auto w-full md:w-1/3 mb-2 text-center  font-bold">
                                <p className="w-full text-xl my-6 text-green-500">{msj}</p>
                            </div>
                        )}
                        {!statusReservations ? (
                            <>
                                <div className="w-full md:w-3/5 lg:w-1/2 mx-auto flex-none md:flex  py-4 md:py-6 md:px-16 border-2 bg-white shadow-lg rounded-xl">
                                    <div className="w-full md:w-2/3 px-4 md:px-0 pb-10 md:pb-0">
                                        <PaymentLabels
                                            title="Fecha"
                                            icon="date"
                                            value={`${filter.date}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Desde"
                                            icon="time"
                                            value={`${filter.start} Hrs -  ${filter.end} Hrs`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Cancha"
                                            icon="field"
                                            value={filter.fieldName}
                                            sport={sport}
                                        />
                                        <PaymentLabels title="Lugar" icon="club" value={`${nameClub}`} sport={sport} />
                                        <PaymentLabels
                                            title="Dirección"
                                            icon="location"
                                            value={`${filter.address || ''}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels title="Nombre" icon="user" value={`${name}`} sport={sport} />
                                        <PaymentLabels title="Email" icon="email" value={`${email}`} sport={sport} />
                                        {phone && (
                                            <PaymentLabels title="Teléfono" icon="phone" value={phone} sport={sport} />
                                        )}
                                        {!priceState.isLoading && priceRent && priceRent.basePrice && (
                                            <PaymentLabels
                                                title="Total"
                                                icon="pay"
                                                value={`${formatPrice(priceRent.basePrice, 0)}`}
                                                sport={sport}
                                            />
                                        )}
                                    </div>
                                    <div className="w-full md:w-2/6 text-center justify-center content-center">
                                        <h3 className="text-xl font-bold italic text-sm-defy pb-4">
                                            Total a pagar {priceRent?.paymentMethods?.code === 'CASH' && ' en cancha'}{' '}
                                        </h3>
                                        {priceState.isLoading && <Loading />}
                                        {!priceState.isLoading && deposit && (
                                            <div className="flex flex-col text-center justify-center content-center">
                                                <p className="text-4xl pt-4 font-bold italic text-sm-integrate">{`${formatPrice(
                                                    deposit,
                                                    0,
                                                )}`}</p>

                                                {priceRent?.paymentMethods?.code !== 'CASH' && (
                                                    <Image
                                                        className="mx-auto px-6 pt-8"
                                                        imgClassName=""
                                                        src={WebPayLogo}
                                                        alt="WebPay"
                                                        width={150}
                                                    />
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-col mx-auto w-full md:w-1/3 mt-6 mb-2" ref={inputRefButton}>
                                    <Button
                                        title={
                                            priceRent?.paymentMethods?.code === 'CASH'
                                                ? 'Reservar'
                                                : isRedirecting
                                                ? 'Espera un momento...'
                                                : 'Pagar'
                                        }
                                        handlerClick={handleSubmit}
                                        disabled={isRedirecting || priceState.isLoading}
                                    />
                                </div>
                            </>
                        ) : (
                            <MsjSuccess
                                className={'top-0 bg-sm-rent '}
                                classSecondary={'mt-10 md:mt-0 md:w-1/4 lg:w-1/3'}
                            >
                                <>
                                    <p className="pt-12 text-center text-2xl font-bold italic">
                                        Tu Reserva se ha realizado con éxito
                                    </p>
                                    <p className="">_________________________</p>
                                    <p className="pt-2 px-6 text-center text-xl font-semibold italic">
                                        Recuerda que el pago se hace presencial en la caja del club.
                                    </p>
                                </>
                            </MsjSuccess>
                        )}
                        {error && (
                            <div className="flex flex-col mx-auto w-full md:w-1/3 mt-2 mb-2 text-center  font-bold">
                                <p className="w-full my-6 text-red-500">*{error}</p>
                            </div>
                        )}
                    </>
                </LayoutInside>
            </>
        </Layout>
    );
};

export default ClubsPayment;
